import TemplateView from "../TemplateView";

export default class Switcher extends TemplateView {
    constructor({
        additionalClass,
        onSwitchCallback
    }) {
        super(null)

        this.additionalClass = additionalClass;
        this.onSwitchCallback = onSwitchCallback;

        this.state = {
            enabled: false,
            readOnly: false,
            animated: false,
        }

        this.onStatePropertyChanged('enabled', enabled => {
                this._updateEnabled(enabled)
        })

        this.onStatePropertyChanged('readOnly', readOnly => this.getEl().toggleClass('disabled', readOnly))

        this.onStatePropertyChanged('animated', animated => {
            this.getEl().toggleClass('animated', animated)
        })
    }

    templateHtml() {
        return '<div class="components_switcher <%=additionalClass%>"/>'
    }

    templateModel() {
        return {
            additionalClass: this.additionalClass
        }
    }

    afterRender() {
        this.getEl().on('click', () => {
            if (!this.state.readOnly) {
                this.setState({enabled: !this.state.enabled})
                this.onSwitchCallback(this.state.enabled)
            }
        })

        this.renderInitialState()
    }

    _updateEnabled(enabled) {
        this.getEl().toggleClass('on', enabled)
        this.getEl().toggleClass('off', !enabled)
    }
}


// WEBPACK FOOTER //
// ./web/js/components/Switcher.js